import { API_HOST } from './constants';

const crypto = require("crypto");
const apiuser = '3f4d31793e35f5653964e809ac41c5b2';
const apipassword = '5f6ead9cef7794d36ec1ab07167e1549';
const apiheaders = {
    'Authorization': 'Basic ' + btoa(apiuser + ":" + apipassword),
    'content-type': 'application/json'
};

const encryptdata = (text, password, callback) => {
    let cipher = crypto.createCipher('aes-256-ctr', password);
    let crypted = cipher.update(text, 'utf8', 'hex');
    crypted += cipher.final('hex');

    callback(crypted);
};

export const Basic = () => {
    return {
        headers: apiheaders,
        method: 'GET',
        credentials: "include"
    };
};

export const BasicPost = (data) => {
    return {
        headers: apiheaders,
        method: 'POST',
        credentials: "include",
        body: JSON.stringify(data)
    };
};

export const Encrypt = (data) => {
    return new Promise((reslove, reject) => {
        let resultenc = {
            headers: apiheaders,
            method: 'POST',
            credentials: "include",
            body: []//่json
        };

        if (data) {

            fetch(`${API_HOST}/authenticate/token`, {
                headers: apiheaders,
                method: 'POST',
                credentials: "include"
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
                else {
                    throw new Error(`${response.status}-${response.statusText}`);
                }
            }).then(response => {
                let token = response.token;
                let jsondata = JSON.stringify(data);

                encryptdata(jsondata, token, (encdata) => {
                    let bodydata = { key: (`${encdata}${token}`) };
                    //let bodydata = { key: (`${encdata}`) };
                    resultenc.body = JSON.stringify(bodydata);
                    reslove(resultenc);
                })

            }).catch(err => {
                console.log(err);
                reject(err);
            });
        }
        else {
            reslove(resultenc);
        }
    });
};



// WEBPACK FOOTER //
// ./src/SecurityPost.js